import React, { Component } from 'react';
import UploadPanel from '../upload/UploadPanel';
import ReactTable from 'react-table';
import _ from 'underscore';
import BusySpinner from '../../components/spinners/BusySpinner';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import Logger, {ALL_MESSAGES, LOG_LEVELS} from '../../utils/logger';
import MERGE_XML_FILES_CONTROLLER from '../../controllers/mergeXmlFiles';

const log = new Logger('MERGE_XML_FILES', LOG_LEVELS.DEBUG);
let fileListStringBuffer =[] ;
let fileCounter = 0

const NoDataComponent = (props) => {
	return (
		<div className ="bold" style={{"textAlign" :"center"}}>
			<br/>
			<LanguageStringResolver string='mergeXMLFiles_noFilesSelected'/>
		</div>
	);
};
class MergeXmlFilesPage extends Component {

	constructor(props) {
		super(props);
		this.onUploadRequest = this.onUploadRequest.bind(this);
		this.onMergeFiles = this.onMergeFiles.bind(this);
		this.onClearAllFiles = this.onClearAllFiles.bind(this);
		this.state ={fileListData:[],loader:false};
	}

	onUploadRequest(files) {
		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_ERROR);
		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_VALIDATION);

		let	filesToBeSent = files[0]
		let fileReader = new FileReader();

		fileReader.onload = (function(fileReader) {
			return function(){
				fileListStringBuffer.push({"index":fileCounter,fileName : filesToBeSent.name,fileString :fileReader.result})
				fileCounter ++;
			}
		})(fileReader);
		fileReader.readAsText(filesToBeSent);
		this.setFileNameListDataState(filesToBeSent);
	}

	setFileNameListDataState(filesToBeSent){
		let currentFileListData = this.state.fileListData ||[];
		currentFileListData.push({"index": fileCounter, "fileName": filesToBeSent.name});
		this.setState({ fileListData: currentFileListData });
	}

	onMergeFiles(){
		if(this.state.fileListData.length > 1)
		{
		 	log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_ERROR);
	 		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_VALIDATION);
			try{
				MERGE_XML_FILES_CONTROLLER.getMergedFile(this.state.fileListData,fileListStringBuffer);
			}
			catch(error){
	 			log.debug('Error occured in XML file merge operation: ', error);
				log.setDictionaryMessage(ALL_MESSAGES.MERGE_XML_FILE_ERROR);
			}
			finally{
				this.setState({loader :false});
			}
		}else{
			log.setDictionaryMessage(ALL_MESSAGES.MERGE_XML_FILE_VALIDATION);
		}
	}

	onClearAllFiles(){
		fileListStringBuffer =[] ;
		fileCounter = 0
		this.setState({fileListData:[]});
		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_ERROR);
		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_VALIDATION);
	}

	onRemoveFileClick(e, state, rowInfo, column, instance) {
		const row  = rowInfo.original || {};
		let fileNameListData = this.state.fileListData ||[];
		fileNameListData = _.reject(fileNameListData, function(record){ return record.index === row.index });
		this.setState({ fileListData: fileNameListData });
		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_ERROR);
		log.clearDictionaryError(ALL_MESSAGES.MERGE_XML_FILE_VALIDATION);
    }

	render() {
		log.debug('render(): ', this.props, this);

		const columns = [{
			Header: () => (<span>file name</span>),
			accessor: 'fileName'
		  },{
			width: 200,
			Header: () => (<span>action</span>),
			Cell: ({ original }) => {
				return (
				  <div>
						<button className="link"><span className="bold"><LanguageStringResolver string='mergeXMLFiles_removeFile'/> </span></button>
				  </div>
				);
			  }
		  }]

    return (

		<s-container className="mb50">
			<BusySpinner busy={this.state.loader} />
			<ApplicationMessages
                    messageIds={[ ALL_MESSAGES.MERGE_XML_FILE_ERROR,
                                  ALL_MESSAGES.MERGE_XML_FILE_VALIDATION
                                ]}
                    messageType="applicationError"
                />

			<s-row style={{"height":450}}>
				<s-col span="4">
					<fieldset>
						<label className="mt10"><LanguageStringResolver string='mergeXMLFiles_uploadXMLFile'/></label>
						<UploadPanel
							uploadLimit={1}
							acceptTypes={[".xml"]}
							clearSelection={true}
							onUploadRequest={this.onUploadRequest}
						/>
					</fieldset>
				</s-col>
				<s-col span="6">
					<fieldset>
						<label className="mt10"><LanguageStringResolver string='mergeXMLFiles_filesToMerge'/> </label>
						<ReactTable
							minRows={0}
							maxRows={0}
							style={this.state.fileListData.length > 5 ? { height: "330px"}:{ height: "100%"}}
							data={this.state.fileListData || []}
							columns={columns}
							showPagination ={false}
							NoDataComponent={NoDataComponent}
							resizable={true}
							sortable={false}
							className="mb20"
							getTrProps={(state, rowInfo, column, instance) => {
                                return {
                                    onClick: e => {
                                        this.onRemoveFileClick(e, state, rowInfo, column, instance);
                                    }
                                }
                            }}
						/>
					</fieldset>
					<button className="primary mt15" onClick = {this.onMergeFiles} ><LanguageStringResolver string='mergeXMLFiles_mergeFile'/> </button>
					<button className="secondary mt15" onClick = {this.onClearAllFiles} ><LanguageStringResolver string='mergeXMLFiles_clearAllFile'/> </button>
				</s-col>
			</s-row>

		</s-container>
		)
  }
}

export default MergeXmlFilesPage;